<template lang="pug">
CommonLoadBox(:loaded="loaded" v-if="!loaded || visible")
  template(slot="skeleton")
    MarketingTaskSkeleton
  template(slot="module")
    div(v-if="visible")
      MarketingTask(
        v-if="showMutilTask"
        :moduleData="moduleData"
        @expired="handleExpired"
      )
      SurpriseTask(
        v-else
        :moduleData="moduleData"
        @expired="handleExpired"
      )
</template>

<script>
import CommonLoadBox from '@/components/common-load-box';
import eventBus from '@/const/eventBus';
import { getTaskListData } from '../../common/task';
import { taskGroupListAdapter } from '../../common/helper';
import { WELFARE_VERSION } from '../../consts';
import MarketingTaskSkeleton from '../cpns-skeleton/marketing-task-skeleton';
import SurpriseTask from './surprise-task';
import MarketingTask from './marketing-task';

export default {
  name: 'TaskWrapper',
  components: {
    CommonLoadBox,
    MarketingTaskSkeleton,
    SurpriseTask,
    MarketingTask,
  },
  provide() {
    return {
      newTaskScene: () => true,
      taskScene: () => WELFARE_VERSION.NEW_TASK_SCENE_V2,
    };
  },
  props: {
    moduleKey: {
      type: String,
      default: '',
    },
    points: {
      type: Number,
      default: 0,
    },
    bounty: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {
      moduleData: {},
      loaded: false,
      visible: false,
      showMutilTask: false,
    };
  },
  created() {
    this.getTaskData();
  },
  mounted() {
    eventBus.$on('refreshSurpriseTask', () => {
      this.getTaskData();
    });
    document.addEventListener(
      'visibilitychange',
      this.handleVisibilityChange,
    );
  },
  beforeDestroy() {
    eventBus.$off('refreshSurpriseTask');
    document.removeEventListener(
      'visibilitychange',
      this.handleVisibilityChange,
    );
  },
  methods: {
    handleVisibilityChange() {
      if (document.visibilityState === 'visible') {
        this.getTaskData();
      }
    },
    async handleExpired() {
      // 领奖后重新拉取数据，根据刷新结果决定是否移除模块
      await this.getTaskData();
      if (!this.visible) {
        this.$emit('expired');
      }
    },
    async getTaskData() {
      try {
        const { data } = await getTaskListData({
          newTaskScene: true,
          newWelfare: true,
        });
        const { taskGroupInfoDTOS = [] } = data || {};
        this.loaded = true;

        const list = taskGroupInfoDTOS.filter(
          (item) => item.moduleKey === 'welfare_surprise_tasks',
        );

        if (!list.length) {
          this.visible = false;
          return;
        }
        // 是否展示多单任务样式，2表示多单任务样式，1表示惊喜任务样式
        this.showMutilTask = list[0].moduleTaskStyleType === '2';
        const taskModuleList = await taskGroupListAdapter(
          { list, isRefresh: false },
          () => { this.getTaskData(); },
        );

        if (!taskModuleList || !taskModuleList.length) {
          this.visible = false;
          return;
        }
        const firstGroup = taskModuleList[0] || {};
        this.moduleData = firstGroup;
        if (!firstGroup.taskCouponList) return;
        this.visible = true;
      } catch (error) {
        // eslint-disable-next-line no-console
        console.error('[TaskWrapper] getTaskData error:', error);
        this.loaded = true;
        this.visible = false;
      }
    },
  },
};
</script>
